export default "__VITE_ASSET__Z9FBmKv9__"